export const MFO_TOP_OFFERS_HEADERS = [
  'МФО',
  'Сумма в руб.',
  'Ставка в %',
  'Срок в днях',
  'Мин. переплата в руб.',
  'Макс. переплата в руб.',
];
